<template>
  <!-- WIDGET -->
  <div id="TrioHP">
    <choose-mortgage v-if="!type"></choose-mortgage>
    <funnel-mortgage v-if="type === 'simulate-mortgage'"></funnel-mortgage>
    <afford-mortgage v-if="type === 'afford-mortgage'"></afford-mortgage>
    <div class="Trio-brand-footer">
      <span class="Trio-brand-text">Powered by</span>
      <a
        href="#"
        @click="openLink(config_url + '/?utm_source=' + utm_source + '&utm_medium=web&utm_campaign=listing')"
        title="Trioteca"
      >
        <img :src="'img/' + brand + '/logo-trioteca.png'" alt="Trioteca" />
      </a>
    </div>
  </div>
</template>

<script>
import chooseMortgage from "./chooseMortgage.vue";
import affordMortgage from "./affordMortgage.vue";
import funnelMortgage from "./funnelMortgage.vue";
import { Store } from "../store/index.js";
import { config } from "../config.js";

export default {
  name: "TrioWidget",
  components: { affordMortgage, chooseMortgage, funnelMortgage },
  computed: {
    type() {
      return Store.getters["ui/type"];
    },
    config_url() {
      return config.url;
    },
    brand() {
      return process.env.VUE_APP_BRAND;
    },
    utm_source() {
      return config.source[this.brand];
    }
  },
  mounted() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type == "ui/SET_STEP") {
        if (state.ui.type == "simulate-mortgage") {
          window.parent.postMessage(
            {
              type: state.ui.type,
              step: state.ui.step,
              uuid: state.mortgageData.uuid,
              totalMortgages: state.mortgageLean.total
            },
            "*"
          );
        } else if (state.ui.type == "afford-mortgage") {
          window.parent.postMessage(
            {
              type: state.ui.type,
              step: state.ui.step,
              uuid: state.mortgageData.uuid,
              amount_f: state.mortgageAfford.publicMortgage
                ? state.mortgageAfford.publicMortgage.fix
                : null,
              amount_v: state.mortgageAfford.publicMortgage
                ? state.mortgageAfford.publicMortgage.variable
                : null
            },
            "*"
          );
        }
      }
    });
  },
  methods: {
    openLink: function(url) {
      window.open(url, "_blank");
    }
  }
};
</script>
